import { View } from 'foundations-components/components/View';
import { EcosystemListingStub } from 'trellis-ecosystem';
import { AutocompleteItem } from './AutocompleteItem';
import { SearchGroupItem } from './SearchGroupItem';
import { jsx as _jsx } from "react/jsx-runtime";
export function SearchOption({
  item,
  searchTerm
}) {
  var _item$productTypes;
  switch (item.resultType) {
    case 'QUERY':
      return /*#__PURE__*/_jsx(AutocompleteItem, {
        keyword: searchTerm,
        suggestion: item.term,
        queryType: item.queryType,
        "aria-label": "search query"
      });
    case 'LISTING':
      return /*#__PURE__*/_jsx(View, {
        paddingInlineStart: "200",
        children: /*#__PURE__*/_jsx(EcosystemListingStub, {
          compact: true,
          imageSrc: item.iconUrl || '',
          name: item.term || '',
          productType: ((_item$productTypes = item.productTypes) === null || _item$productTypes === void 0 ? void 0 : _item$productTypes[0]) || 'APP',
          providerName: item.providerName || 'HubSpot'
        })
      });
    case 'CATEGORY':
      return /*#__PURE__*/_jsx(SearchGroupItem, {
        item: item,
        keyword: searchTerm
      });
    case 'COLLECTION':
      return /*#__PURE__*/_jsx(SearchGroupItem, {
        item: item,
        keyword: searchTerm
      });
    default:
      return null;
  }
}